<template>
    <div>
        <!-- 创建/编辑试卷 弹窗：创建模块 -->
        <el-dialog :title="moduleOldName?renameTextConfig.title:renameTextConfig.addTitle" v-if="creatDialogVisible"
                   :visible.sync="creatDialogVisible" width="500px" @close="creatClose" :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <el-form :model="creatForm" :rules="creatRules" ref="creatForm" label-width="80px">
                <el-form-item v-if="!moduleOldName" :label="renameTextConfig.form.type" prop="type">
                    <el-select v-model="creatForm.type" @change="typeChange"
                               :placeholder="renameTextConfig.form.typeTip">
                        <el-option
                                v-for="item in $parent.typeOptions"
                                :key="item.dict_value"
                                :label="item.dict_label"
                                :value="item.dict_value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="renameTextConfig.form.name" prop="name">
                    <el-input v-model="creatForm.name" maxlength="100" :placeholder="renameTextConfig.form.nameTip"
                              show-word-limit
                              clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="creatClose()">{{ renameTextConfig.cancel }}</el-button>
                <el-button type="primary" @click="submitCopyPaperForm('creatForm')">{{
                    renameTextConfig.ok
                    }}</el-button>
            </span>
        </el-dialog>
        <!-- 创建/编辑试卷 弹窗：添加题目 -->
        <el-dialog class="addQuestionDialog" :title="addTextConfig.title.signMix(ModuleName)" :visible.sync="addDialogVisible" width="1000px"
                   @close="addClose" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form class="form" :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-select v-model="isAll" style="width:100px">
                        <el-option :label="searchTextConfig.isAll.all" :value="0"></el-option>
                        <el-option :label="searchTextConfig.isAll.checked" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.bank_id" :loading="roleChildLoading" v-el-select-loadmore="remoteMethod"
                               :placeholder="searchTextConfig.bankIdTip" clearable style="width:180px">
                        <el-option v-for="item in roleChildOptions" :key="item.id" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.stem" clearable :placeholder="searchTextConfig.stemTip" style="width:180px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.difficulty" clearable :placeholder="searchTextConfig.difficultyTip" style="width:100px">
                        <el-option v-for="item in difficultyOptions" :key="item.dict_value" :label="item.dict_label"
                                   :value="item.dict_value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-cascader v-model="tag_ids" @change="tagCheck" :placeholder="searchTextConfig.tagTip" :options="tagOptions"
                                 :props="tagProps" collapse-tags :show-all-levels="false" filterable clearable>
                        <template slot-scope="{ node, data }">
                            <span>{{ data.name }}</span>
                            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                        </template>
                    </el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                      ref="multipleTable" :data="tableData" @select="onTableSelect" @select-all="handleSelectionChange"
                      stripe size="medium" :height="height" style="width:100%">
                <el-table-column type="selection" :selectable="selectable" width="48" fixed="left"
                                 align="center"></el-table-column>
                <el-table-column prop="newStem" :label="tableTextConfig.newStem" :min-width="flexColumnWidth('newStem',2,tableData)"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="bank_name" :label="tableTextConfig.bankName"
                                 :min-width="flexColumnWidth('difficulty',2,tableData)"></el-table-column>
                <el-table-column :label="tableTextConfig.difficulty" min-width="60">
                    <template slot-scope="scope">
                        {{ difficultyFormatter(scope.row.difficulty) }}
                    </template>
                </el-table-column>
                <el-table-column prop="tags" :label="tableTextConfig.tag" :min-width="flexColumnWidth('tags',2,tableData)"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-for="item in scope.row.tags" :key="item.id"><el-tag type="info">{{ item.name }}</el-tag>&nbsp;&nbsp;</span>
                        {{ !(scope.row.tags && scope.row.tags.length > 0) ? '无' : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="score" :label="scoreLabel" min-width="65" show-overflow-tooltip>
                    <template slot-scope="scope">{{ tableTextConfig.scoreTip.signMix(scope.row.score) }}</template>
                </el-table-column>
            </el-table>
            <div style="position: relative;height:32px;margin-top:15px">
                <span style="position: absolute;">已选：{{ checkData.length }} &nbsp;&nbsp;&nbsp;&nbsp;<el-button
                        @click="clearData" :disabled="!checkData.length" type="danger" size="mini">{{ tableTextConfig.clear }}</el-button></span>
                <el-pagination v-show="total"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="form.page_number"
                               :page-sizes="[10, 20, 30, 50]"
                               :page-size="form.page_size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total"
                               background>
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">{{ tableTextConfig.cancel }}</el-button>
                <el-button type="primary" @click="submitForm('form')">{{ tableTextConfig.ok }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ['creatModuleShow', 'moduleOldName', 'addQuestionShow', 'ModuleType', 'disableData'],
    directives: {
        'el-select-loadmore': {
            bind(el, binding) {
                // 获取element-ui定义好的scroll盒子
                const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
                SELECTWRAP_DOM.addEventListener('scroll', () => {
                    /**
                     * scrollHeight 获取元素内容高度(只读)
                     * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                     * clientHeight 读取元素的可见高度(只读)
                     * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                     * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                     */
                    const condition = SELECTWRAP_DOM.scrollHeight - SELECTWRAP_DOM.scrollTop <= SELECTWRAP_DOM.clientHeight
                    if (condition) {
                        binding.value()
                    }
                })
            },
        },
    },
    data() {
        return {
            creatDialogVisible: false,
            creatForm: {
                id: null,
                name: '',
                type: ''
            },
            creatRules: {
                name: [
                    {
                        required: true,
                        message: this.$store.state.global.textConfig.backend.testPaperEdit.model.button.rename.form.nameRule,
                        trigger: 'change'
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (/^[\u4E00-\u9FA5A-Za-z0-9()（）]+$/g.test(value) == false && value) {
                                callback(new Error("仅支持输入中英文、数字、圆括号"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
                type: [
                    {
                        required: true,
                        message: this.$store.state.global.textConfig.backend.testPaperEdit.model.button.rename.form.typeRule,
                        trigger: 'change'
                    },
                ],
            },
            addDialogVisible: false,
            ModuleName: '',
            isAll: 0,
            scoreLabel: this.$store.state.global.textConfig.backend.testPaperEdit.question.button.add.table.score,
            form: {
                bank_id: null,
                stem: '',
                type: '',
                difficulty: '',
                tag_ids: '',
                page_number: 1,
                page_size: 20
            },
            tag_ids: '',
            total: 0,
            difficultyOptions: [],
            questionTypeOptions: [],
            tagProps: {multiple: true, expandTrigger: 'hover', emitPath: false, value: 'id', label: 'name'},
            tagOptions: [],
            selectRow: [],
            checkData: [],
            tableData: [],
            loading: false,
            roleChildLoading: false,
            roleChildOptions: [],
            questionBankForm: {
                name: '',
                status: null,
                page_number: 1,
                page_size: 20
            },
            res: 1,
            height: 250,
            clickSubmit: false,
        };
    },
    computed: {
        renameTextConfig() {
            return this.$store.state.global.textConfig.backend.testPaperEdit.model.button.rename
        },
        addTextConfig() {
            return this.$store.state.global.textConfig.backend.testPaperEdit.question.button.add
        },
        searchTextConfig() {
            return this.addTextConfig.search
        },
        tableTextConfig() {
            return this.addTextConfig.table
        },
    },
    watch: {
        creatModuleShow() {
            this.creatDialogVisible = this.creatModuleShow;
        },
        moduleOldName() {
            if (this.moduleOldName) {
                this.creatForm.name = this.moduleOldName
            }
        },
        addQuestionShow() {
            this.addDialogVisible = this.addQuestionShow
        },
        ModuleType() {
            this.form.type = this.ModuleType.type
            this.checkData = JSON.parse(JSON.stringify(this.ModuleType.list))
            this.ModuleName = this.questionTypeFormatter(this.ModuleType.type)
            this.search(1)
        },
        tableData() {
            if (this.tableData.length == 0) {
                this.height = 140
            } else {
                this.updateHeight()
            }
        }
    },
    methods: {
        typeChange(val) {
            var obj = {}
            obj = this.$parent.typeOptions.find(function (item) {
                return item.dict_value === val
            })
            // if (!this.creatForm.name) {
            this.creatForm.name = obj.dict_label
            // }
        },
        creatClose() {
            this.creatForm.id = null
            if (!this.clickSubmit) this.creatForm.name = ''
            this.$emit('creatModuleDialogClose', this.creatForm.name)
            this.creatForm.name = ''
            this.creatForm.type = ''
            this.creatDialogVisible = false
            this.clickSubmit = false
        },
        addClose() {
            this.form = {
                bank_id: null,
                stem: '',
                type: '',
                difficulty: '',
                tag_ids: '',
                page_number: 1,
                page_size: 20
            }
            this.tag_ids = ''
            this.isAll = 0
            this.scoreLabel = this.tableTextConfig.score
            this.$parent.addQuestionDialogVisible = false
            this.addDialogVisible = false
        },
        selectable(row, index) {
            let bool = true
            if (this.disableData) {
                for (let i = 0; i < this.disableData.length; i++) {
                    const id = this.disableData[i];
                    if (row.id == id) bool = false
                }
            }
            return bool
        },
        remoteMethod() {
            if (this.res == 1) {
                // this.roleChildLoading = true
                setTimeout(() => {
                    this.$store.dispatch("getQuestionList", this.questionBankForm).then(res => {
                        if (res.data.list.length < 20) this.res = 0
                        // this.roleChildLoading = false
                        this.roleChildOptions.push(...res.data.list)
                        this.questionBankForm.page_number += 1
                    });
                }, 500);
            }
        },
        tagCheck() {
            this.form.tag_ids = this.tag_ids.join(',')
        },
        onTableSelect(rows, row) {
            let selected = rows.length && rows.indexOf(row) !== -1
            if (selected) {
                this.$store.dispatch("getQuestionPreview", row.id).then(res => {
                    if (this.checkData.length > 0) {
                        let same = false
                        for (let j = 0; j < this.checkData.length; j++) {
                            const f = this.checkData[j];
                            if (row.id == f.id) {
                                same = true
                            }
                        }
                        if (!same) {
                            this.checkData.push(res.data)
                        }
                    } else {
                        this.checkData.push(res.data)
                    }
                })
            } else {
                for (let j = 0; j < this.checkData.length; j++) {
                    const f = this.checkData[j];
                    if (row.id == f.id) {
                        this.checkData.splice(j, 1)
                    }
                }
            }
        },
        handleSelectionChange(val) {
            if (val.length) {
                for (let i = 0; i < val.length; i++) {
                    const e = val[i];
                    this.$store.dispatch("getQuestionPreview", e.id).then(res => {
                        if (this.checkData.length > 0) {
                            let same = false
                            for (let j = 0; j < this.checkData.length; j++) {
                                const f = this.checkData[j];
                                if (e.id == f.id) {
                                    same = true
                                }
                            }
                            if (!same) {
                                this.checkData.push(res.data)
                            }
                        } else {
                            this.checkData.push(res.data)
                        }
                    })
                }
            } else {
                if (this.isAll == 0) {
                    for (let i = 0; i < this.tableData.length; i++) {
                        const e = this.tableData[i];
                        let same = -1
                        for (let j = 0; j < this.checkData.length; j++) {
                            const f = this.checkData[j];
                            if (e.id == f.id) {
                                same = j
                            }
                        }
                        if (same != -1) {
                            this.checkData.splice(same, 1)
                        }
                    }
                } else {
                    this.checkData = []
                    this.tableData = []
                }

            }

        },
        clearData() {
            this.$refs.multipleTable.clearSelection()
            this.checkData = []
            if (this.isAll == 1) {
                this.tableData = []
            }
        },
        search(val) {
            this.loading = true
            if (this.isAll == 1) {
                this.total = 0
                this.scoreLabel = this.tableTextConfig.currentScore
                this.tableData = JSON.parse(JSON.stringify(this.checkData))
                this.$nextTick(() => {
                    for (let k = 0; k < this.tableData.length; k++) {
                        const n = this.tableData[k];
                        n.newStem = n.stem.replace(/<img[^>]*[>|...]/g, '【图片】')
                        if (n.type == 'fill') {
                            n.newStem = (n.newStem.replace(/\[\[(.*?)\]\]/g, '________________')).replace(/<[^<>]+>/g, '')
                        } else {
                            n.newStem = n.newStem.replace(/<[^<>]+>/g, '')
                        }
                        let term = false
                        if (n.newStem.toLowerCase().indexOf(this.form.stem.toLowerCase()) !== -1) {
                            term = true
                        }
                        this.$refs.multipleTable.toggleRowSelection(this.$refs.multipleTable.data[k], true);//默认选中
                        if (term && (!this.form.bank_id || this.form.bank_id === n.bank_id) && (!this.form.tag_ids || this.form.tag_ids === n.tag_ids) && (!this.form.difficulty || this.form.difficulty === n.difficulty)) {
                        } else {
                            this.tableData.splice(k, 1)
                            k--
                        }

                    }
                    this.loading = false
                })
            } else {
                if (val) {
                    this.form.page_number = val
                }
                this.tableData = []
                this.$store.dispatch("getAllQuestion", this.form).then(res => {
                    this.loading = false
                    this.tableData = res.data.list
                    let arr = []
                    for (let i = 0; i < this.tableData.length; i++) {
                        const e = this.tableData[i];
                        e.newStem = e.stem.replace(/<img[^>]*[>|...]/g, '【图片】')
                        if (e.type == 'fill') {
                            e.newStem = (e.newStem.replace(/\[\[(.*?)\]\]/g, '________________')).replace(/<[^<>]+>/g, '')
                        } else {
                            e.newStem = e.newStem.replace(/<[^<>]+>/g, '')
                        }
                        if (this.checkData.length) {
                            for (let j = 0; j < this.checkData.length; j++) {
                                const f = this.checkData[j];
                                if (e.id == f.id) {
                                    arr.push(i)
                                }
                            }
                        }
                    }
                    this.total = res.data.total
                    this.form.page_number = res.data.pageNumber
                    if (arr.length) {
                        this.$nextTick(() => {
                            for (let k = 0; k < arr.length; k++) {
                                const n = arr[k];
                                this.$refs.multipleTable.toggleRowSelection(this.$refs.multipleTable.data[n], true);//默认选中
                            }
                        })
                    }
                    this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                    this.scoreLabel = this.tableTextConfig.score
                }).catch(err => {
                    this.loading = false
                })
            }
            this.$nextTick(() => {
                this.$refs.multipleTable.doLayout()
            })
        },
        reset() {
            this.form = {
                bank_id: null,
                stem: '',
                type: this.ModuleType.type,
                difficulty: '',
                tag_ids: '',
                page_number: 1,
                page_size: 20
            }
            this.tag_ids = ''
            this.isAll = 0
            this.search(1)
        },
        handleSizeChange(val) {
            this.form.page_size = val
            this.search(1)
        },
        handleCurrentChange(val) {
            this.form.page_number = val
            this.search(val)
        },
        submitForm(formName) {
            if (this.checkData.length) {
                this.$message({
                    message: this.tableTextConfig.success,
                    type: 'success'
                });
            }
            this.addDialogVisible = false
            this.$emit('addQuestionDialogClose', {data: this.checkData, index: this.ModuleType.index})
        },
        submitCopyPaperForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.moduleOldName) {
                        this.clickSubmit = true
                        this.creatClose()
                        this.$message({
                            message: this.renameTextConfig.editSuccess,
                            type: 'success'
                        });
                    } else {
                        // this.$store.dispatch("postQuestion", this.questionForm).then(res => {
                        // if (res.status == 200) {
                        this.$parent.question.push({
                            name: this.creatForm.name,
                            question_type: this.creatForm.type,
                            total_score: 0,
                            question_list: []
                        })
                        this.$message({
                            message: this.renameTextConfig.addSuccess,
                            type: 'success'
                        });
                        this.$parent.temporaryPaperSave()
                        this.creatClose()
                        //     }
                        // });
                    }

                } else {
                    return false;
                }
            });
        },
        updateHeight() {
            this.height = document.body.clientHeight - 412
            this.height = this.height < 250 ? 250 : this.height
        },
        difficultyFormatter(val) {
            let already = this.difficultyOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        questionTypeFormatter(val) {
            let already = this.questionTypeOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        }
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    created() {
        this.$store.dispatch("getDict", 'question_difficulty').then(res => {
            this.difficultyOptions = res.data
        });
        this.$store.dispatch("getDict", 'question_type').then(res => {
            this.questionTypeOptions = res.data
        });
        this.$store.dispatch("getQuestionTagList").then(res => {
            this.tagOptions = []
            for (let i = 0; i < res.data.length; i++) {
                const e = res.data[i];
                if (i != (res.data.length - 1)) {
                    this.tagOptions.push(e)
                } else {
                    this.tagOptions.push(...e.children)
                }
            }
        });
        this.remoteMethod()
    },
};
</script>

<style>

</style>